/// <reference path="./Tag.ts" />
namespace HA.Core.HTML {
    //noinspection TsLint
    export class Iframe extends Tag {

        /**
         * @param data
         */
        protected initialize(data: any) {

            data.set("html", "<iframe width=\”560\″ height=\”315\″ src=\""+ data.get("src") +"\" title=\"YouTube video player\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>");
            super.initialize(data);
        }

        /**
         *
         * @returns {string}
         */
        public getTagName() {
            return "iframe";
        }
    }
}
